import React, { Component } from 'react';
import NegotiationLotsTableList from './Lots/NegotiationLotsTableList';
import DropdownListAPI from '../../API/DropdownListAPI';
import NegotiationLotEditForm from './EditLots/NegotiationLotEditForm';
import SnackbarAlert from '../Utils/SnackbarAlert';
import { handleServerError } from '../../Utils/Helper';
import { FP_MODULE } from '../../Utils/Constants';

export class NegotiationContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      negotiationLotStateList: [],
      negotiationLot: {},
      shouldReloadList: false,
      showNegotiationLotEditForm: false,
      openError: false,
      alertMessage: ''
    };
  }

  componentDidMount() {
    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getAllLotStates(FP_MODULE, true).then((response) => {
      this.setState({
        negotiationLotStateList: response.data,
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      });
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  openEditLotMainForm(oNegLot, optionaisDescription) {
    this.setState({
      showNegotiationLotEditForm: !this.state.showNegotiationLotEditForm,
      negotiationLot: oNegLot,
      optionaisDescriptionState: optionaisDescription
    });
  }

  reloadNegotiationLotsTableList() {
    this.setState({ shouldReloadList: true });
    this.setState({ shouldReloadList: false });
  }


  render() {

    return (
      <div>
        <NegotiationLotsTableList
          negotiationLotStateList={this.state.negotiationLotStateList}
          openEditLotMainForm={this.openEditLotMainForm.bind(this)}
          titleNegLot={this.props.titleTableListNegLot}
          titleTableList={this.props.titleTableList}
          shouldReloadList={this.state.shouldReloadList}
          showContent={this.props.showContent}
        />

        {(!this.state.negotiationLot) ? null :
          <NegotiationLotEditForm
            open={this.state.showNegotiationLotEditForm}
            reloadNegotiationLotsTableList={this.reloadNegotiationLotsTableList.bind(this)}
            openEditLotMainForm={this.openEditLotMainForm.bind(this)}
          />
        }

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    )
  }
}

export default NegotiationContent;


// WEBPACK FOOTER //
// ./src/components/Negotiation/NegotiationContent.js